
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1sxt8_1wd0y_100",
  "header": "awsui_header_1sxt8_1wd0y_140",
  "test-utils-drawer-content": "awsui_test-utils-drawer-content_1sxt8_1wd0y_169"
};
  